import React from "react";
import * as styles from "./velavu-alert-modal.module.scss";
import VelavuModalContainer from "../velavu-modal-container";

export interface VelavuAlertModalProps {
	children?: React.ReactNode;
}

export default function VelavuAlertModal(props: VelavuAlertModalProps) {
	return (
		<VelavuModalContainer className={styles.container}>
			{props.children}
		</VelavuModalContainer>
	);
}
